import type { FieldFill, MerchantFieldFill } from './api';
import { Pill, fmtDay } from './ui';

/**
 * [BIZ v4 #29] Values leads gave a merchant. Filled: the merchant's field was
 * empty and took the lead's value. Different: the merchant already had
 * another value, so it was left alone and the lead's value is shown here.
 */
export default function FieldFills({ fills, onOpenLead }: { fills: (FieldFill | MerchantFieldFill)[]; onOpenLead?: (lead: number) => void }) {
  const conflicts = fills.filter((f) => f.outcome === 'conflict');
  const filled = fills.filter((f) => f.outcome === 'filled');
  const origin = (f: FieldFill | MerchantFieldFill) => 'lead' in f ? (
    <span className="li-muted">
      {' '}from {onOpenLead
        ? <button type="button" className="li-btn li-btn--link" onClick={() => onOpenLead(f.lead)}>{f.source ?? 'a lead'}{f.batch_date ? `, ${fmtDay(f.batch_date)}` : ''}</button>
        : <>{f.source ?? 'a lead'}{f.batch_date ? `, ${fmtDay(f.batch_date)}` : ''}</>}
    </span>
  ) : null;
  return (
    <div className="li-stack li-stack--tight" data-testid="li-field-fills">
      {conflicts.length > 0 && (
        <table className="li-table li-table--compact" aria-label="Different values">
          <thead><tr><th>Field</th><th>Lead says</th><th>Merchant has</th></tr></thead>
          <tbody>
            {conflicts.map((f, i) => (
              <tr key={i}>
                <td>{f.label}</td>
                <td><b>{f.lead_value}</b>{origin(f)}</td>
                <td>{f.merchant_value ?? <span className="li-muted">Not visible to you</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {filled.length > 0 && (
        <ul className="li-list" aria-label="Filled fields">
          {filled.map((f, i) => (
            <li key={i}><Pill tone="success">filled</Pill> {f.label}: <b>{f.lead_value}</b>{origin(f)}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
